// This object keeps all the photos for the main feature autoplay in the opeening of the site
export const mainFeaturePhotoRoll = [ 
	{
		id: 0,
        image: '/assets/images/mainFeature/MainTop-0-2trees.jpg'
	},
	{
		id: 1,
        image: '/assets/images/mainFeature/MainTop-1-skis.jpg'
	},
	{
		id: 2,
        image: '/assets/images/mainFeature/MainTop-2-goryu.jpg'
	},
	{
		id: 3,
        image: '/assets/images/mainFeature/MainTop-3-valley.jpg'
	},
	{
		id: 4,
        image: '/assets/images/mainFeature/MainTop-4-yari.jpg'
	},
    {
		id: 5,
        image: '/assets/images/mainFeature/MainTop-5-frost.jpg'
	},
	{
		id: 6,
        image: '/assets/images/mainFeature/MainTop-6-rainbow.jpg'
	},
	{
		id: 7,
        image: '/assets/images/mainFeature/MainTop-7-2trees.jpg'
	},
	{
		id: 8,
        image: '/assets/images/mainFeature/MainTop-8-sled.jpg'
	}
]